var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "url(#paint0_linear_58_155532)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3142 33.6174C36.2722 33.6286 36.2282 33.6346 36.1828 33.6346H16.8165C16.771 33.6346 16.727 33.6286 16.685 33.6174L22.7225 27.5831L24.0045 28.8964C25.3816 30.3072 27.6176 30.3073 28.9948 28.8964L30.2767 27.5831L36.3142 33.6174ZM36.6921 32.9726V21.0028C36.6921 20.9417 36.6813 20.8832 36.6616 20.8289C36.6315 20.8986 30.633 27.0657 30.633 27.0657L36.6748 33.1043C36.6861 33.0623 36.6921 33.0181 36.6921 32.9726ZM16.3076 33.0236V21.0539C16.3076 20.9928 16.3184 20.9343 16.3382 20.88C16.3682 20.9497 22.3667 27.1167 22.3667 27.1167L16.3248 33.1554C16.3136 33.1134 16.3076 33.0692 16.3076 33.0236ZM36.3385 20.3943L28.6296 28.2854C27.4524 29.4914 25.546 29.4913 24.3689 28.2854C24.3689 28.2854 19.2305 23.0255 16.6613 20.3956C16.638 20.3717 36.3385 20.3943 36.3385 20.3943Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_155532",
    x1: 26.5,
    y1: 0,
    x2: 26.5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AD4FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLg);
export default __webpack_public_path__ + "static/media/email-lg.bea9e4f9ea3e01ac61a395ee305f5329.svg";
export { ForwardRef as ReactComponent };